// src/pages/AdminLogin.js
import React from 'react';
import Header from '../components/Header'; // Adjust the path if necessary
import Footer from '../components/Footer'; // Adjust the path if necessary
import '../styles/AdminLogin.css'; // Ensure to import the styles for this page

function AdminLogin() {
    return (
        <div className="main-container">
            {/* Header */}
            <Header />

            {/* Login Form */}
            <div className="login-container">
                <form>
                    <h2>Admin Login</h2> {/* Admin Login Header */}
                    <div className="form-group">
                        <label htmlFor="username">Username</label>
                        <input type="text" id="username" name="username" required />
                    </div>
                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input type="password" id="password" name="password" required />
                    </div>
                    <button type="submit">Login</button>
                </form>
            </div>

            {/* Footer */}
            <Footer />
        </div>
    );
}

export default AdminLogin;
